import classNames from 'classnames'
import { AnimatePresence, motion } from 'framer-motion'
import { ReactNode } from 'react'

interface IProps {
  bgClasses: string
  children: ReactNode
  onClick?: () => void
}

export const CardContainer: React.FC<IProps> = ({ bgClasses, children, onClick }) => (
  <AnimatePresence>
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className={classNames('rounded-[35px] p-6', bgClasses)}
      onClick={() => {
        if (onClick) {
          onClick()
        }
      }}
    >
      {children}
    </motion.div>
  </AnimatePresence>
)
